<template>
  <div>
    <v-card elevation="0" tile class="pt-6">
      <v-row>
        <v-col cols="12" md="3"><strong>{{
          $t("accountSettings.security.currentPass")
            }}</strong></v-col>
        <v-col cols="12" md="9"><v-text-field @input="v$.form.password.$touch()" :type="showPass1 ? 'text' : 'password'"
            @blur="v$.form.password.$touch()" :error-messages="passwordErrors" v-model="form.password" outlined>
            <template v-slot:[`append`]>
              <v-icon v-if="!showPass1" @click="showPass1 = !showPass1">mdi-eye</v-icon>
              <v-icon v-else @click="showPass1 = !showPass1">mdi-eye-off</v-icon>
            </template>
          </v-text-field></v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pt-6">
        <v-col cols="12" md="3"><strong>{{
          $t("accountSettings.security.newPass")
            }}</strong></v-col>
        <v-col cols="12" md="9"><v-text-field @input="v$.form.newPassword.$touch()" :type="showPass2 ? 'text' : 'password'"
            @blur="v$.form.newPassword.$touch()" :error-messages="newPasswordErrors" v-model="form.newPassword"
            outlined>
            <template v-slot:[`append`]>
              <v-icon v-if="!showPass2" @click="showPass2  = !showPass2">mdi-eye</v-icon>
              <v-icon v-else @click="showPass2 = !showPass2">mdi-eye-off</v-icon>
            </template>
          </v-text-field></v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pt-6">
        <v-col cols="12" md="3"><strong>{{
          $t("accountSettings.security.confirmPass")
            }}</strong></v-col>
        <v-col cols="12" md="9"><v-text-field @input="v$.form.confirm.$touch()" :type="showPass3 ? 'text' : 'password'"
            @blur="v$.form.confirm.$touch()" :error-messages="confirmErrors" required v-model="form.confirm"
            outlined>
            <template v-slot:[`append`]>
              <v-icon v-if="!showPass3" @click="showPass3  = !showPass3">mdi-eye</v-icon>
              <v-icon v-else @click="showPass3 = !showPass3">mdi-eye-off</v-icon>
            </template>
          </v-text-field></v-col>
      </v-row>
      <div class="d-flex pb-6">
        <v-spacer></v-spacer>
        <v-btn :disabled="disabledBtn" color="#075f2e" large class="white--text" elevation="0" :loading="loading"
          @click="submit">{{ this.$t('common.save') }}</v-btn>

      </div>
    </v-card>
    <v-divider></v-divider>

    <v-row class="pt-6">
      <v-col cols="12" md="3"><strong>{{ $t('accountSettings.security.loginHistory') }}</strong></v-col>
      <v-col cols="12" md="9">
        <v-card outlined :loading="loadingHistoric">
          <v-data-table :headers="loginHeaders" :items="list" :items-per-page="5">
            <template v-slot:[`item.createdOn`]="{ item }">
              {{ item.createdOn | dateTimeTz(item.timezone) }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span class="green--text" v-if="item.status == 'success'">
                <v-icon size="20" class="mr-2" color="green">mdi-shield-check</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
              <span class="red--text" v-if="item.status == 'blocked'">
                <v-icon size="20" class="mr-2" color="red">mdi-lock-clock</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
              <span class="orange--text" v-if="item.status == 'password_error'">
                <v-icon size="20" class="mr-2" color="orange">mdi-alert-circle-outline</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
            </template>
          </v-data-table>
        </v-card></v-col>
    </v-row>

  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, sameAs } from "@vuelidate/validators";
import { mapActions } from "vuex";
import moment from 'moment-timezone'

export default {
  name: "SecurityLog",

  data: () => ({
    showPass1: false,
    showPass2: false,
    showPass3: false,
    loadingHistoric: true,
    list: [],
    loading: false,
    form: {
      password: "",
      confirm: "",
      newPassword: "",
    },
    newPassword: "",

  }),

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      form: {
        password: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(20),
        },
        newPassword: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(20),
        },
        confirm: { required, sameAs: sameAs(this.form.newPassword) },
      },
      // // if(this.assets.countries[this.country].code == 'PER'){
      //   validationsList.form.document.validFormat = isValidPeruRUC
      // // }

      // return validationsList
    };
  },

  computed: {
    mtz() {
      return moment.tz.guess(true)
    },
    loginHeaders() {
      return [
        // { text: 'ID', value: 'uid' },

        { text: this.$t("accountSettings.security.date"), value: "createdOn" },
        { text: this.$t("accountSettings.security.os"), value: "plataform" },
        { text: "IP", value: "remoteAddr" },
        { text: "Status", value: "status", align: "center" },

      ];
    },
    disabledBtn() {
      return this.v$.$invalid
    },

    invalid() {
      if (!this.v$.$dirty) return false;
      return this.v$.$invalid || this.form.password == this.form.newPassword;
    },
    passwordErrors() {
      const errors = [];
      if (!this.v$.form.password.$dirty) return errors;
      this.v$.form.password.minLength.$invalid &&
        errors.push(
          this.$t("accountSettings.security.err.minLengthPass", { count: 6 })
        );
      this.v$.form.password.maxLength.$invalid &&
        errors.push(
          this.$t("accountSettings.security.err.maxLengthPass", { count: 20 })
        );
      this.v$.form.password.required.$invalid &&
        errors.push(this.$t("accountSettings.security.err.requiredPass"));
      return errors;
    },
    confirmErrors() {
      const errors = [];
      if (!this.v$.form.confirm.$dirty) return errors;
      this.v$.form.confirm.sameAs.$invalid &&
        errors.push(this.$t("accountSettings.security.err.samePass"));
      this.v$.form.confirm.required.$invalid &&
        errors.push(this.$t("accountSettings.security.err.requiredPass"));
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.v$.form.newPassword.$dirty) return errors;

      this.v$.form.newPassword.minLength.$invalid &&
        errors.push(
          this.$t("accountSettings.security.err.minLengthPass", { count: 6 })
        );
      this.v$.form.newPassword.maxLength.$invalid &&
        errors.push(
          this.$t("accountSettings.security.err.maxLengthPass", { count: 20 })
        );
      this.form.newPassword == this.form.password &&
        errors.push(this.$t("accountSettings.security.err.diff"));
      this.v$.form.newPassword.required.$invalid &&
        errors.push(this.$t("accountSettings.security.err.requiredPass"));
      return errors;
    },
  },

  created() {

  },
  mounted() {
    this.getLogins()
  },
  methods: {


    ...mapActions("snackbar", ["showSnack"]),
    getLogins() {
      this.loadingHistoric = true
      const url = `users/historic?id=${this.$root.auth.user.uid}`;
      this.$axios
        .get(url)
        .then((res) => {
          this.loadingHistoric = false
          this.list = res.data.data
        })
    },
    submit() {
      if (!this.v$.$invalid && this.form.password != this.form.newPassword) {
        let form = {
          oldPassword: this.form.password,
          password: this.form.newPassword,
          passwordConfirm: this.form.confirm,
        };

        this.v$.$touch();
        // if (!this.v$.$invalid) {
        this.loading = true;
        const url = `users/password`;
        const headers = this.$root.authToken;
        this.$axios
          .put(url, form, {
            headers,
          })
          .then((res) => {
            this.showSnack({
              text: this.$t("auth.password.reset.snackSucess"),
              color: "success",
              timeout: 4000,
              icon: "mdi-check",
            });
            console.log(res);
            this.loading = false;

          })
          .catch((err) => {
            this.loading = false;
            const error = err.response.data.errors;
            console.error("ERR", error);
            // if (error[0].hasOwnProperty("password")) {
            //   this.errorsOldPassword.push(error[0].password);
            // }
          });
      }

      //}
    },
  },
};
</script>
